import { useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import formatStartDate from "../helpers/formatStartDate"
import { PriceSummaryResponse } from "../models"
import queryKeys from "../queryKeys"

const usePriceSummary = (resortId: number, arrivalDate: Date) => {
  const formattedDate = formatStartDate(arrivalDate)
  return useQuery<PriceSummaryResponse>({
    queryKey: queryKeys.priceSummary(resortId, formattedDate),
    queryFn: async () => {
      const res = await bffApi.get<PriceSummaryResponse>(`/price-summary`, {
        params: {
          resortId,
          arrivalDate: formattedDate,
        },
      })
      return res.data
    },
    enabled: Boolean(resortId) && Boolean(arrivalDate),
    staleTime: 0,
    gcTime: 0,
  })
}

export default usePriceSummary
